<ng-template #loaderSingle>
  <i class="button_spinner light-center-absolute"></i>
</ng-template>
<section>
  <div class="recent_searches_content background-container-background">
    @if (recentSearches) {
      @if (recentSearches.length) {
        <div class="recent_searches_recent">
          <!-- <a
          i18n="@@RemoveAll"
          class="remove-all"
          (click)="removeAll()"
          (keydown.enter)="removeAll()"
          role="button"
          tabindex="0"
          aria-label="Remove all recent searches">
          Remove all
        </a> -->
          <ul>
            @for (item of recentSearches; track item; let i = $index) {
              <li class="recent-search-item" [@fadeInOut]>
                @if (item) {
                  <!-- ! BOLT ITEM -->
                  <div
                    aria-label="Perfrom Recent Bolt Search"
                    class="storageItem"
                    [@fadeInOut]
                    tabindex="0"
                    role="button"
                    (keydown.enter)="performRecentSearch(item)"
                    (click)="performRecentSearch(item)"
                  >
                    <div class="icons">
                      <i class="ico-bolt input_icon" aria-hidden="true"></i>
                    </div>
                    <div class="details">
                      <span class="title" id="recent_search_{{ i }}">
                        {{ item.searchArgs.departure.title }} -
                        {{ item.searchArgs.destination.title }}
                      </span>
                      <span class="Date"
                        >{{ item.searchArgs.departureDate | sabsDate: 1 }}
                        <!-- if return jorney  -->
                        {{
                          item.searchArgs.returnDate
                            ? ' - ' + (item.searchArgs.returnDate | sabsDate: 1)
                            : ''
                        }}
                      </span>
                      <br />
                      <br />
                      <app-recent-search-travellers
                        [travellers]="item.travellers"
                      ></app-recent-search-travellers>
                    </div>
                    <div
                      class="recent-search-remove"
                      (click)="removeRecentSearchItem(item, $event)"
                      (keydown.enter)="removeRecentSearchItem(item, $event)"
                      tabindex="0"
                      role="button"
                      attr.aria-labelledby="remove_recent_search_hint recent_search_{{ i }}"
                    >
                      <i class="ico-trash"></i>
                    </div>
                  </div>
                } @else {
                  <div class="recent_searches_no_recent">
                    <i class="button_spinner light-center-absolute"></i>
                    <span i18n="@@YLoadingRecentSearchesMessage">Loading recent searches...</span>
                  </div>
                }
              </li>
            }
          </ul>
        </div>
      }
      @if (recentSearches.length === 0) {
        <div class="recent_searches_no_recent">
          <i class="ico-search no_recent_icon" aria-hidden="true"></i>
          <h2 class="no_recent_header" i18n="@@YouHaveNoRecentSearches">
            You have no recent searches
          </h2>
          <p class="no_recent_tag_line" i18n="@@YouHaveNoRecentSearchesMessageStop">
            All searches you perform will appear here so you can quickly pick up where you left off
            anytime.
          </p>
          <p></p>
        </div>
      }
    } @else {
      <div class="recent_searches_no_recent">
        <i class="button_spinner light-center-absolute"></i>
        <span i18n="@@YLoadingRecentSearchesMessage">Loading recent searches...</span>
      </div>
    }
    <span id="remove_recent_search_hint" hidden>Remove recent search</span>
  </div>
</section>
